<template>
    <section class="p-3">
        <FormSection
            :full-height="false"
            :title="visitDetails.TaskName"
            :application-id="visitDetails.Application"
            :show-product-pill="true"
        >
            <template #content>
                <template v-if="isLoading">
                    <div
                        class="p-5 d-flex flex-column align-items-center justify-content-center text-center text-primary"
                    >
                        <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                        <strong class="mt-1">
                            <b>Loading...</b>
                        </strong>
                    </div>
                </template>
                <template class="dialog position-relative" v-else>
                    <div class="container row m-0 p-1">
                        <div class="col-sm-12 col-md-6 mt-2">
                            <div v-if="!visitDetails.IsNonVisitAssignment" class="form-group">
                                <label for="client-name"> Client </label>
                                <input
                                    id="client-name"
                                    type="text"
                                    class="form-control"
                                    v-model="taskDetails.scheduleEvent.patientName"
                                    disabled
                                />
                            </div>
                            <div v-if="!visitDetails.IsNonVisitAssignment" class="form-group">
                                <label for="mrn"> MRN </label>
                                <input
                                    id="mrn"
                                    type="text"
                                    class="form-control"
                                    v-model="taskDetails.scheduleEvent.patientIdNumber"
                                    disabled
                                />
                            </div>
                            <div v-if="visitDetails.IsNonVisitAssignment" class="form-group">
                                <label for="client-name"> Caregiver/User </label>
                                <input
                                    id="client-name"
                                    type="text"
                                    class="form-control"
                                    v-model="assignedToName"
                                    disabled
                                />
                            </div>
                            <div
                                class="form-group"
                                v-if="taskDetails.disciplineTasks.length > 0 && !visitDetails.IsNonVisitAssignment"
                            >
                                <label for="task-name"> Task </label>
                                <TypeaheadInput
                                    id="task-name"
                                    :getData="availableTasksFilter"
                                    :value="selectedTask"
                                    v-on:valueChanged="changeTaskList"
                                    placeholder="Type to Select Task"
                                    :show-all-by-default="true"
                                    :open-on-focus="true"
                                    :disabled="isPlanner"
                                />
                            </div>
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="travel-start-time"> Scheduled Start Time: </label>
                                <div class="d-flex gx-1">
                                    <DatePicker :getDate="handleDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="eventStartTime"
                                                id="schedule-date"
                                                type="text"
                                                class="form-control"
                                                :value="formatDateInput(taskDetails.scheduleEvent.eventStartTime)"
                                                :disabled="!areFieldsEnabled"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                    <TimePicker
                                        @update-props="changeIsAllDay"
                                        class="flex-fill ms-1"
                                        v-if="!taskDetails.scheduleEvent.isAllDay"
                                    >
                                        <input
                                            id="travel-start-time"
                                            type="text"
                                            class="form-control"
                                            :value="scheduledStartTime"
                                            autocomplete="off"
                                            :maxlength="8"
                                            :disabled="!areFieldsEnabled"
                                        />
                                    </TimePicker>
                                </div>
                            </div>
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="travel-end-time"> Scheduled End Time: </label>
                                <div class="d-flex gx-1">
                                    <DatePicker :getDate="handleDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="eventEndTime"
                                                id="schedule-date"
                                                type="text"
                                                class="form-control"
                                                :value="formatDateInput(taskDetails.scheduleEvent.eventEndTime)"
                                                :disabled="!areFieldsEnabled"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                    <TimePicker
                                        @update-props="changeScheduleEndTime"
                                        class="flex-fill ms-1"
                                        v-if="!taskDetails.scheduleEvent.isAllDay"
                                    >
                                        <input
                                            id="travel-end-time"
                                            type="text"
                                            class="form-control"
                                            :value="scheduledEndTime"
                                            autocomplete="off"
                                            :maxlength="8"
                                            :disabled="!areFieldsEnabled"
                                        />
                                    </TimePicker>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="actual-visit-date"> Actual Visit Date/Time In: </label>
                                <div class="d-flex gx-1">
                                    <DatePicker :getDate="handleDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="visitStartTime"
                                                id="actual-visit-date"
                                                type="text"
                                                class="form-control"
                                                :value="formatDateInput(taskDetails.scheduleEvent.visitStartTime)"
                                                :disabled="!areFieldsEnabled"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                    <TimePicker
                                        @update-props="changeVisitTimeIn"
                                        class="flex-fill ms-1"
                                        v-if="!taskDetails.scheduleEvent.isAllDay"
                                    >
                                        <input
                                            id="travel-end-time"
                                            type="text"
                                            class="form-control timepicker"
                                            :value="visitTimeIn"
                                            autocomplete="off"
                                            :maxlength="8"
                                            :disabled="!areFieldsEnabled"
                                        />
                                    </TimePicker>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="visit-start-time"> Actual Visit Date/Time Out: </label>
                                <div class="d-flex gx-1">
                                    <DatePicker :getDate="handleDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="visitEndTime"
                                                id="actual-visit-date"
                                                type="text"
                                                class="form-control"
                                                :value="formatDateInput(taskDetails.scheduleEvent.visitEndTime)"
                                                :disabled="!areFieldsEnabled"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                    <TimePicker
                                        @update-props="changeVisitTimeOut"
                                        class="flex-fill ms-1"
                                        v-if="!taskDetails.scheduleEvent.isAllDay"
                                    >
                                        <input
                                            id="visit-start-time"
                                            type="text"
                                            class="form-control"
                                            :value="visitTimeOut"
                                            autocomplete="off"
                                            :maxlength="8"
                                            :disabled="!areFieldsEnabled"
                                        />
                                    </TimePicker>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="form-group form-check custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="schedule-without-time"
                                        class="form-check-input"
                                        v-model="taskDetails.scheduleEvent.isAllDay"
                                        :disabled="isPlanner"
                                    />
                                    <label class="form-check-label" for="schedule-without-time">
                                        Schedule Without Time
                                    </label>
                                </div>
                            </div>
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <div class="form-group form-check custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id="billable"
                                        class="form-check-input"
                                        v-model="taskDetails.scheduleEvent.isBillable"
                                        :disabled="isPlanner"
                                    />
                                    <label class="form-check-label" for="billable"> Billable </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-2">
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="client-name"> Care Period </label>
                                <input
                                    id="client-name"
                                    type="text"
                                    class="form-control"
                                    :value="getCarePeriod"
                                    disabled
                                />
                            </div>
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="status"> Status: </label>
                                <select
                                    class="form-select"
                                    id="status"
                                    v-model="taskDetails.scheduleEvent.status"
                                    :disabled="isPlanner"
                                >
                                    <option v-for="status of taskDetails.statuses" :value="status.value">
                                        {{ status.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group" v-if="!showAssignedToList && !visitDetails.IsNonVisitAssignment">
                                <label for="assigned-to"> Assigned To: </label>
                                <input
                                    type="text"
                                    id="assigned-to"
                                    class="form-control"
                                    v-model="assignedToName"
                                    disabled
                                />
                            </div>
                            <div class="form-group" v-else-if="!visitDetails.IsNonVisitAssignment">
                                <label for="assigned-to-list"> Assigned To: </label>
                                <TypeaheadInput
                                    id="assigned-to-list"
                                    :getData="employeeListFilter"
                                    :value="scheduleEmployee"
                                    v-on:valueChanged="changescheduleEmployee"
                                    placeholder="Select User"
                                    :show-all-by-default="true"
                                    :open-on-focus="true"
                                    :disabled="isPlanner"
                                />
                            </div>
                            <div class="form-group">
                                <label for="surcharge"> Surcharge: </label>
                                <input
                                    id="surcharge"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    v-number-only
                                    :maxlength="7"
                                    v-model="taskDetails.scheduleEvent.surcharge"
                                    :disabled="isPlanner"
                                />
                            </div>
                            <div class="form-group">
                                <label for="associated-mileage"> Associated Mileage: </label>
                                <input
                                    id="associated-mileage"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    v-number-only
                                    :maxlength="7"
                                    v-model="taskDetails.scheduleEvent.associatedMileage"
                                    :disabled="isPlanner"
                                />
                            </div>
                            <div class="form-group">
                                <label for="travel-time"> Travel Time (mins): </label>
                                <input
                                    id="travel-time"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter time"
                                    v-number-only
                                    :maxlength="7"
                                    v-model="taskDetails.scheduleEvent.travelTime"
                                    :disabled="isPlanner"
                                />
                            </div>
                            <div class="form-group" v-if="showPhyicianField && !visitDetails.IsNonVisitAssignment">
                                <label for="physician-name"> Physician </label>
                                <TypeaheadInput
                                    id="physician-name"
                                    placeholder="Start Typing"
                                    :getData="getPhysicianList"
                                    :value="physician"
                                    v-on:valueChanged="physicianChanged"
                                    :disabled="isPlanner"
                                />
                            </div>
                            <div
                                class="form-group"
                                v-if="isReturnedWithSignature && !visitDetails.IsNonVisitAssignment"
                            >
                                <label for="received-date"> Received Date: </label>
                                <DatePicker>
                                    <div class="input-group date datepickerInput">
                                        <input
                                            id="received-date"
                                            type="text"
                                            class="form-control"
                                            :value="formatDateInput(taskDetails.scheduleEvent.orderReceivedDate)"
                                            placeholder="MM/DD/YYYY"
                                            :disabled="isPlanner"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                            </div>
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="payer-list"> Payer: </label>
                                <select
                                    id="payer-list"
                                    class="form-select"
                                    v-model="taskDetails.scheduleEvent.payorId"
                                    @change="selectedPayor(taskDetails.scheduleEvent.payorId)"
                                    :disabled="isPlanner"
                                >
                                    <option :value="null">-- Select Payment Source --</option>
                                    <option v-for="payor of payorList" :value="payor.insuranceId">
                                        {{ payor.name }} ({{ payor.typeName }})
                                    </option>
                                </select>
                            </div>
                            <div class="form-group" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="confirmation-status"> Confirmation Status: </label>
                                <select
                                    id="confirmation-status"
                                    class="form-select"
                                    v-model="confirmationStatus"
                                    :disabled="!areFieldsEnabled"
                                >
                                    <option :value="0">Select Confirmation Status</option>
                                    <option
                                        v-for="[index, status] in enumToMap(confirmationStatusEnum)"
                                        :value="status.value"
                                        :key="status.value"
                                    >
                                        {{ status.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group col-12" v-if="!visitDetails.IsNonVisitAssignment">
                            <h6 class="mt-2 d-flex align-items-center">
                                <b class="me-2">Gross Profit Forecast</b>
                            </h6>
                            <div class="row mt-2">
                                <div class="form-group col-4">
                                    <label for="billing-amount"> Billing Amount: </label>
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text rate-icon py-1">$</span>
                                        </div>
                                        <input
                                            id="billing-amount"
                                            type="text"
                                            class="form-control"
                                            maxlength="7"
                                            v-model="taskDetails.scheduleEvent.billingAmount"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="form-group col-4">
                                    <label for="payroll-amount"> Payroll Amount: </label>
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text rate-icon py-1">$</span>
                                        </div>
                                        <input
                                            id="payroll-amount"
                                            type="text"
                                            class="form-control"
                                            maxlength="7"
                                            v-model="taskDetails.scheduleEvent.payrollAmount"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="form-group col-4">
                                    <label for="gross-profit"> Gross Profit Percentage: </label>
                                    <div class="input-group input-group-sm">
                                        <input
                                            id="gross-profit"
                                            type="text"
                                            class="form-control"
                                            :maxlength="7"
                                            v-model="taskDetails.scheduleEvent.grossProfit"
                                            disabled
                                        />

                                        <div class="input-group-append">
                                            <span class="input-group-text px-2 py-1">
                                                <small><i class="fas fa-percent text-secondary"></i></small>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="form-group col-12"
                            v-if="
                                taskDetails &&
                                taskDetails.scheduleEvent.taskShifts.length > 0 &&
                                !visitDetails.IsNonVisitAssignment
                            "
                        >
                            <h6 class="mt-2 d-flex align-items-center">
                                <b class="me-2">Midnight Split</b>
                            </h6>
                            <MidnightSplitTable :task-shifts="taskDetails.scheduleEvent.taskShifts" />
                        </div>
                        <div v-if="!visitDetails.IsNonVisitAssignment" class="form-group col-12">
                            <h6 class="mt-2 d-flex align-items-center">
                                <b class="me-2">Payroll Details</b>
                            </h6>
                            <PayrollDetailsTable
                                :has-payroll-details="hasPayrollDetails"
                                :payroll-details="payrollDetails"
                                :get-payroll-details="getPayrollDetails"
                                :payroll-details-loading="payrollDetailsLoading"
                            />
                        </div>
                        <section class="d-flex flex-column col-12 px-3 py-2">
                            <div class="form-group">
                                <label v-if="!visitDetails.IsNonVisitAssignment" for="comments">
                                    Comments <i class="ms-2 fas fa-sticky-note yellow"></i> (Yellow Sticky Note)
                                </label>
                                <label v-else for="comments"> Comments </label>
                                <CommentInput
                                    id="comments"
                                    input-name="referral-comments"
                                    placeholder="Enter Comments"
                                    :class-list="commentInputClass"
                                    :application="visitDetails.Application"
                                    :show-template-typeahead="false"
                                    :show-template-dropdown="false"
                                    :result="taskDetails.scheduleEvent.comments"
                                    v-on:resultUpdatedAppended="resultUpdatedAppended"
                                    v-on:resultUpdated="resultUpdated"
                                    :disabled="isPlanner"
                                />
                            </div>
                        </section>
                        <section
                            v-if="!visitDetails.IsNonVisitAssignment"
                            class="d-flex flex-column col-12 px-3 py-2"
                            slot="content"
                        >
                            <div class="form-group">
                                <label for="return-reason">
                                    Return Reason <i class="ms-2 fas fa-sticky-note orange"></i> (Orange Sticky Note)
                                </label>
                                <div
                                    v-if="returnReasons.length > 0"
                                    :class="`${
                                        isDeleteRequested
                                            ? 'p-2 mb-2 bg-white rounded border border-secondary edit-row'
                                            : 'p-2 mb-2 bg-white rounded border border-secondary'
                                    }`"
                                    v-for="reasonCode of returnReasons"
                                >
                                    <div class="d-flex justify-content-between">
                                        <div class="fw-bold">
                                            {{ reasonCode.user }}
                                            <sup
                                                ><i>{{ formatDate(reasonCode.date) }}</i></sup
                                            >
                                        </div>
                                    </div>
                                    <div>{{ reasonCode.reason }}</div>
                                </div>
                                <div
                                    class="p-2 mb-2 bg-white rounded border border-secondary"
                                    v-if="!returnReasons.length"
                                >
                                    <div class="text-center fst-italic">No Return Reason Found</div>
                                </div>
                            </div>
                        </section>
                        <section v-if="!visitDetails.IsNonVisitAssignment" class="d-flex flex-column col-12 p-2">
                            <div class="form-group">
                                <VisitAttachmentsHC :visitDetails="visitDetails" :isPlanner="isPlanner" />
                            </div>
                        </section>
                    </div>
                    <div
                        class="d-flex justify-content-center mb-3 position-sticky bg-background-home-care-form-section p-2 z-index-10 bottom-0"
                        v-if="!isLoading"
                    >
                        <span v-if="isSaving">
                            <button class="btn btn-primary">
                                <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                            </button>
                        </span>
                        <span v-else>
                            <button class="btn btn-primary" @click="updateVisitDetails()">Save</button>
                            <button type="button" class="ms-1 btn btn-md btn-outline-secondary" @click="closeDialog()">
                                Cancel
                            </button>
                        </span>
                    </div>
                </template>
            </template>
        </FormSection>
    </section>
</template>

<style scoped>
.orange {
    color: orange;
}

.yellow {
    color: #fff400;
}
</style>

<script src="./VisitDetailsHomeCare.ts"></script>
<style src="./VisitDetailsHomeCare.scss"></style>
